module.exports = __webpack_public_path__ + "img/c36b0cd1d39a20df149556aec5a0afc1.png";